import { GraphQLClient } from 'graphql-request';
import { Config } from '#lib/constants/config.js';
import { browser } from '$app/env';
import { fetchWithRetry } from '$global/utils/fetchWithRetry/fetchWithRetry';
import { createRequestWithRetry } from '$global/utils/requestWithRetry/requestWithRetry';

const baseClient = new GraphQLClient(Config.GraphqlApiUrl, {
	...(browser && {
		fetch: fetchWithRetry,
	}),
	headers: {
		authorization: `Bearer ${Config.GraphqlApiKey}`,
	},
});

export const gqlClient = {
	request: createRequestWithRetry(baseClient, browser),
} as unknown as GraphQLClient;
